/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SignUpUser201ResponseAllOfData } from './SignUpUser201ResponseAllOfData';
import {
    SignUpUser201ResponseAllOfDataFromJSON,
    SignUpUser201ResponseAllOfDataFromJSONTyped,
    SignUpUser201ResponseAllOfDataToJSON,
} from './SignUpUser201ResponseAllOfData';

/**
 * 
 * @export
 * @interface SignUpUser201ResponseAllOf
 */
export interface SignUpUser201ResponseAllOf {
    /**
     * 
     * @type {SignUpUser201ResponseAllOfData}
     * @memberof SignUpUser201ResponseAllOf
     */
    data: SignUpUser201ResponseAllOfData;
}

/**
 * Check if a given object implements the SignUpUser201ResponseAllOf interface.
 */
export function instanceOfSignUpUser201ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function SignUpUser201ResponseAllOfFromJSON(json: any): SignUpUser201ResponseAllOf {
    return SignUpUser201ResponseAllOfFromJSONTyped(json, false);
}

export function SignUpUser201ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignUpUser201ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': SignUpUser201ResponseAllOfDataFromJSON(json['data']),
    };
}

export function SignUpUser201ResponseAllOfToJSON(value?: SignUpUser201ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': SignUpUser201ResponseAllOfDataToJSON(value.data),
    };
}

